import React from 'react'

import i18n from 'i18n'

import { OmButton, OmTabs } from '@owma/kit'

import classNames from 'classnames'
import { i18Key } from 'utils'
import { useReadReceipt } from 'vars'
// import { notImplemented } from 'utils/ui'

import {
  FontFamilyMap,
  FontSizeMap,
  TextColorMap,
  CONTACT_TYPE,
  MAILBOX_TYPE,
  SettingsInterface,
} from 'popups/Settings/def'

import dataManager from 'pages/main/data/DataManager'

import { confirmDelete } from 'utils/ui'

import { UIGroup, ViewGroup } from 'utils/ui/propsUI'

import { selectContacts, changeContactsOrder, selectMailboxTypes } from './uiExt'

import settings from '../index'

import styles from './style.module.scss'

import exclimationTri22 from 'assets/images/exclamation-triangle-22.svg'

interface EmailSettingsProps {
  innerRef?: React.MutableRefObject<SettingsInterface | null>
  owner: any
  isMobile?: boolean
  parentLabel?: any
  idx?: string | number
}

interface EmailSettingsState {}

class SettingItem
  extends React.Component<EmailSettingsProps, EmailSettingsState>
  implements SettingsInterface
{
  state: EmailSettingsState = {}

  uiGroupMap: any = {}

  vGroupMap: any = {}

  isUICreated: boolean = false

  editorFont: any = {}

  componentDidMount(): void {
    const { innerRef } = this.props
    if (innerRef != null) {
      innerRef.current = this
    }

    this.applySettings()

    // this.unsubscribe = reduxStore.subscribe(this.onChangeSettings);
  }

  // componentDidUpdate(prevProps) {
  //   const { mailbox, selectedEmail } = this.props
  // }

  componentWillUnmount(): void {
    // if (this.unsubscribe != null) {
    //   this.unsubscribe();
    // }
  }

  // onChangeSettings = () => {
  //   const reduxState = reduxStore.getState()
  //   const { settings } = reduxState

  //   console.log(' --- onChangeSettings : ', settings);
  // }
  createUIGroup = (): void => {
    if (this.isUICreated === true) {
      return
    }

    this.isUICreated = true

    this.createGeneralUIGroup()
    this.createComposeUIGroup()
    this.createSendMessageUIGroup()
    this.createReplyAndForwardUIGroup()
    this.createAdvancedUIGroup()
  }

  createGeneralUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        titleKey: i18Key('settings.fields.threading'),
        desc: null,
      }),
      new ViewGroup({
        titleKey: i18Key('settings.fields.mailList'),
        desc: null,
      }),
    ]

    const customSearchResults = {
      useValue: true,
      onGetValue: (info: any, wrapper: any): void => {
        console.log('customSearchResults onGetValue : ', wrapper, info)
      },
      onSetValue: (value: any, info: any, wrapper: any): void => {
        console.log('customSearchResults onSetValue : ', wrapper, info, value)
      },
      getElement: (info: any, wrapper: any): React.ReactElement => {
        // const { reactObj } = wrapper;
        // console.log(wrapper, info)

        const onClick = (): void => {
          const values = wrapper.getValue() || []
          selectMailboxTypes({
            title: i18n.t('settings.title.showItemsOnThreading'),
            initValues: [...values],
            onOk: (result: any, closeFunc: () => void): void => {
              const { checkedValues } = result
              wrapper.setValue(checkedValues)
              wrapper.notifyChange(checkedValues)
              closeFunc()
            },
          })
        }

        return (
          <OmButton
            key={wrapper.pKey}
            className={classNames('type3', 'h38')}
            onClick={onClick}
            style={{ width: '100%' }}
          >
            {i18n.t('settings.btns.settings')}
          </OmButton>
        )
      },
    }

    const customVisibleThreadItemsDesc = {
      useValue: true,
      onGetValue: (info: any, wrapper: any): void => {
        console.log('customContactSelect onGetValue : ', wrapper, info)
      },
      onSetValue: (value: any, info: any, wrapper: any): void => {
        console.log('customContactSelect onSetValue : ', wrapper, info, value)
      },
      getElement: (info: any /*, wrapper */): React.ReactElement => {
        const { visibleThreadItems } = info.parent
        const value = visibleThreadItems.wrapper.getValue()
        let label = null
        if (!value) {
          label = 'None'
        } else {
          const validIndexList = Object.keys(MAILBOX_TYPE.typeDef).map((key) => {
            return MAILBOX_TYPE.typeDef[key].value
          })

          const strings = value
            .filter((item: any) => {
              return validIndexList.indexOf(item) >= 0
            })
            .map((item: any) => {
              /* i18next-extract-disable-next-line */
              return i18n.t(MAILBOX_TYPE.getLabelKeyByValue(item))
            })
          label = strings.join(', ')
        }
        return (
          <div
            className={styles.visibleThreadItemsDesc}
            style={{
              top: 0,
              right: 0,
            }}
          >
            {label}
          </div>
        )
      },
    }

    const generalProps: any = {
      mailUseThread: {
        labelKey: i18Key('settings.fields.organizeByThread'),
        readOnly: false,
        format: 'om-switch',
        default: true,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[0],
      },
      visibleThreadItems: {
        labelKey: i18Key('settings.fields.visibleThreadItems'),
        readOnly: false,
        format: 'custom',
        ...customSearchResults,
        use: (info: any) => {
          const { mailUseThread } = info.parent
          const useThread = mailUseThread.wrapper.getValue()
          return useThread === true
        },
        vGroup: vGroups[0],
      },
      visibleThreadItemsDesc: {
        label: null,
        readonly: false,
        format: 'custom',
        attrs: {
          className: styles.visibleThreadItemsDescParent,
        },
        ...customVisibleThreadItemsDesc,
        use: (info: any) => {
          const { mailUseThread } = info.parent
          const useThread = mailUseThread.wrapper.getValue()
          return useThread === true
        },
        vGroup: vGroups[0],
      },
      viewMode: {
        labelKey: i18Key('settings.fields.readingPanePosition'),
        readOnly: false,
        format: 'om-select',
        inputAttrs: { popupMatchSelectWidth: false },
        default: 'splitHorizontal',
        values: [
          { value: 'noSplit', labelKey: i18Key('settings.values.readingPanePosition.noSplit') },
          {
            value: 'splitHorizontal',
            labelKey: i18Key('settings.values.readingPanePosition.right'),
          },
        ],
        vGroup: vGroups[1],
      },
      selectionBehavior: {
        labelKey: i18Key('settings.fields.selectionBehavior'),
        readOnly: false,
        format: 'om-select',
        inputAttrs: { popupMatchSelectWidth: false },
        default: 'firstMessage',
        values: [
          {
            value: 'firstMessage',
            labelKey: i18Key('settings.values.selectionBehavior.firstMessage'),
          },
          { value: 'manually', labelKey: i18Key('settings.values.selectionBehavior.manually') },
        ],
        vGroup: vGroups[1],
      },
    }

    this.vGroupMap.general = vGroups

    this.uiGroupMap.general = new UIGroup({
      children: generalProps,
      styles,
      reactObj: this,
    })
  }

  createComposeUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        titleKey: i18Key('settings.subtitle.Stationary'),
        desc: null,
      }),
      new ViewGroup({
        titleKey: i18Key('settings.subtitle.recipientsSearch'),
        descKey: null,
      }),
    ]

    const fontFamilyList = Object.keys(FontFamilyMap).map((key) => {
      return { value: FontFamilyMap[key], label: key }
    })

    const fontSizeList = Object.keys(FontSizeMap).map((key) => {
      return { value: FontSizeMap[key], label: key }
    })

    const colorPresets = [
      {
        label: 'color',
        colors: Object.keys(TextColorMap).map((key) => {
          return TextColorMap[key]
        }),
        key: 'textColor',
      },
    ]

    const customContactSelect = {
      useValue: true,
      onGetValue: (info: any, wrapper: any): void => {
        console.log('customContactSelect onGetValue : ', wrapper, info)
      },
      onSetValue: (value: any, info: any, wrapper: any): void => {
        console.log('customContactSelect onSetValue : ', wrapper, info, value)
      },
      getElement: (info: any, wrapper: any): React.ReactElement => {
        // const { reactObj } = wrapper;
        // console.log(wrapper, info)

        const onClick = (): void => {
          const values = wrapper.getValue()
          selectContacts({
            title: i18n.t('settings.subtitle.recipientsSearchTarget'),
            initValues: [...values],
            onOk: (result: any, closeFunc: () => void): void => {
              const { checkedValues } = result
              wrapper.setValue(checkedValues)
              wrapper.notifyChange(checkedValues)
              closeFunc()
            },
          })
        }

        return (
          <OmButton
            key={wrapper.pKey}
            className={classNames('type3', 'h38')}
            onClick={onClick}
            style={{ width: '100%' }}
          >
            {i18n.t('settings.btns.settings')}
          </OmButton>
        )
      },
    }

    const customSearchTargetDesc = {
      useValue: true,
      onGetValue: (info: any, wrapper: any): void => {
        console.log('customContactSelect onGetValue : ', wrapper, info)
      },
      onSetValue: (value: any, info: any, wrapper: any): void => {
        console.log('customContactSelect onSetValue : ', wrapper, info, value)
      },
      getElement: (info: any /*, wrapper */): React.ReactElement => {
        const { recipientsSearchTarget } = info.parent
        const value = recipientsSearchTarget.wrapper.getValue()
        let label = null
        if (!value) {
          label = 'None'
        } else {
          const validIndexList = Object.keys(CONTACT_TYPE.typeDef).map((key) => {
            return CONTACT_TYPE.typeDef[key].value
          })

          const strings = value
            .filter((item: any) => {
              return validIndexList.indexOf(item) >= 0
            })
            .map((item: any) => {
              /* i18next-extract-disable-next-line */
              return i18n.t(CONTACT_TYPE.getLabelKeyByValue(item))
            })
          label = strings.join(', ')
        }
        return (
          <div
            className={styles.searchTargetDesc}
            style={{
              top: 0,
              right: 0,
            }}
          >
            {label}
          </div>
        )
      },
    }

    const customContactOrder = {
      useValue: true,
      onGetValue: (info: any, wrapper: any): void => {
        console.log(wrapper, info)
      },
      onSetValue: (value: any, info: any, wrapper: any): void => {
        console.log(wrapper, info, value)
      },
      getElement: (info: any, wrapper: any): React.ReactElement => {
        // const { reactObj } = wrapper;

        // console.log(wrapper, info)

        const onClick = (): void => {
          const values = wrapper.getValue()

          changeContactsOrder({
            title: i18n.t('settings.subtitle.recipientsSearchResultOrder'),
            initValues: [...values],
            onOk: (result: any, closeFunc: () => void): void => {
              const { list } = result
              wrapper.setValue(list)
              wrapper.notifyChange(list)
              closeFunc()
            },
          })
        }

        return (
          <OmButton
            key={wrapper.pKey}
            className={classNames('type3', 'h38')}
            onClick={onClick}
            style={{ width: '100%' }}
          >
            {i18n.t('settings.btns.settings')}
          </OmButton>
        )
      },
    }

    const uiProps: any = {
      editorFontFamily: {
        labelKey: i18Key('settings.fields.editorFontFamily'),
        readOnly: false,
        format: 'om-select',
        default: '',
        values: fontFamilyList,
        vGroup: vGroups[0],
      },
      editorFontSizeString: {
        labelKey: i18Key('settings.fields.editorFontSizeString'),
        readOnly: false,
        format: 'om-select',
        default: '11pt',
        values: fontSizeList,
        vGroup: vGroups[0],
      },
      editorFontColorNew: {
        labelKey: i18Key('settings.fields.editorFontColorNew'),
        readOnly: false,
        format: 'om-color',
        default: '#000000',
        showMore: true,
        inputAttrs: {
          presets: colorPresets,
        },
        attrs: {
          className: styles.colorContainer,
        },
        vGroup: vGroups[0],
      },
      editorFontColorReFwd: {
        labelKey: i18Key('settings.fields.editorFontColorReFwd'),
        readOnly: false,
        format: 'om-color',
        default: '#1f497d',
        showMore: true,
        inputAttrs: { presets: colorPresets },
        attrs: {
          className: styles.colorContainer,
        },
        vGroup: vGroups[0],
      },
      recipientsSearchTarget: {
        labelKey: i18Key('settings.fields.recipientsSearchTarget'),
        format: 'custom',
        ...customContactSelect,
        vGroup: vGroups[1],
      },
      recipientsSearchTargetDesc: {
        label: '',
        readonly: false,
        format: 'custom',
        attrs: {
          className: styles.searchTargetDescParent,
        },
        ...customSearchTargetDesc,
        vGroup: vGroups[1],
      },
      recipientsSearchResultOrder: {
        labelKey: i18Key('settings.fields.recipientsSearchResultOrder'),
        format: 'custom',
        ...customContactOrder,
        vGroup: vGroups[1],
      },
    }

    this.vGroupMap.compose = vGroups

    this.uiGroupMap.compose = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  createSendMessageUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        // titleKey: i18Key('settings.fields.mailList'),
        desc: null,
      }),
    ]

    const uiProps: any = {
      confirmBeforeSend: {
        labelKey: i18Key('settings.fields.confirmBeforeSend'),
        readOnly: false,
        format: 'om-switch',
        default: true,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[0],
      },
      ...(useReadReceipt
        ? {
            alwaysRequestReadReceipt: {
              labelKey: i18Key('settings.fields.alwaysRequestReadReceipt'),
              readOnly: false,
              format: 'om-switch',
              default: false,
              attrs: { className: classNames('halfWidth') },
              vGroup: vGroups[0],
            },
          }
        : {}),
    }

    this.vGroupMap.sendMessage = vGroups

    this.uiGroupMap.sendMessage = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  createReplyAndForwardUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        // titleKey: i18Key('settings.fields.mailList'),
        desc: null,
      }),
    ]

    const uiProps: any = {
      showOriginalMessage: {
        labelKey: i18Key('settings.fields.showOriginalMessage'),
        readOnly: false,
        format: 'om-switch',
        default: true,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[0],
      },
    }

    this.vGroupMap.replyAndForward = vGroups

    this.uiGroupMap.replyAndForward = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  createAdvancedUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        titleKey: null,
        descKey: null,
      }),
      new ViewGroup({
        titleKey: i18Key('settings.subtitle.extResource'),
        desc: null,
      }),
      new ViewGroup({
        titleKey: i18Key('settings.subtitle.markRead'),
        descKey: null,
      }),
    ]

    const customObjInitAllowed = {
      onGetValue: (info: any, wrapper: any): void => {
        console.log(wrapper, info)
      },
      onSetValue: (value: any, info: any, wrapper: any): void => {
        console.log(wrapper, info, value)
      },
      getElement: (info: any, wrapper: any): React.ReactElement => {
        // const { reactObj } = wrapper;

        // console.log(wrapper, info)

        const onClick = (): void => {
          confirmDelete({
            icon: <img src={exclimationTri22} alt="exclamation-triangle" />,
            title: i18n.t('settings.btns.initAllowedSender'),
            content: i18n.t('settings.btns.initAllowedSenderDesc'),
            okText: i18n.t('common.button.ok'),
            cancelText: i18n.t('common.button.cancel'),
            onOk: () => {
              this.initAllowedSenders()
            },
          })
        }

        return (
          <OmButton key={wrapper.pKey} className={classNames('type3', 'h38')} onClick={onClick}>
            {i18n.t('settings.btns.initAllowedSenderBtn')}
          </OmButton>
        )
      },
    }

    const advancedProps: any = {
      autoAdvanced: {
        labelKey: i18Key('settings.fields.autoAdvanced'),
        readOnly: false,
        format: 'om-select',
        default: 1,
        values: [
          { value: 0, labelKey: i18Key('settings.values.autoAdvanced.previous') },
          { value: 1, labelKey: i18Key('settings.values.autoAdvanced.next') },
          { value: 2, labelKey: i18Key('settings.values.autoAdvanced.returnToList') },
        ],
        vGroup: vGroups[0],
      },
      isUnknownAlwaysShowExternalResources: {
        labelKey: i18Key('settings.fields.unknownExtRes'),
        readOnly: false,
        format: 'om-select',
        default: 0,
        values: [
          { value: 0, labelKey: i18Key('settings.values.unknownExtRes.always') },
          { value: 1, labelKey: i18Key('settings.values.unknownExtRes.ask') },
        ],
        vGroup: vGroups[1],
      },
      isKnownAlwaysShowExternalResources: {
        labelKey: i18Key('settings.fields.knownExtRes'),
        readOnly: false,
        format: 'om-select',
        default: 0,
        values: [
          { value: 0, labelKey: i18Key('settings.values.knownExtRes.always') },
          { value: 1, labelKey: i18Key('settings.values.knownExtRes.ask') },
        ],
        vGroup: vGroups[1],
      },
      initAllowedSenders: {
        labelKey: null,
        format: 'custom',
        ...customObjInitAllowed,
        vGroup: vGroups[1],
      },
      isMarkAsReadWhenOpen: {
        labelKey: i18Key('settings.fields.markWhenOpen'),
        format: 'om-switch',
        default: true,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[2],
      },
      isMarkAsReadWhenDeleted: {
        labelKey: i18Key('settings.fields.markWhenDeleted'),
        format: 'om-switch',
        default: false,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[2],
      },
      isAutoMarkAsReadWhenReplyingOrForwarding: {
        labelKey: i18Key('settings.fields.markWhenReply'),
        format: 'om-switch',
        default: false,
        attrs: { className: classNames('halfWidth') },
        vGroup: vGroups[2],
      },
    }

    this.vGroupMap.advanced = vGroups

    this.uiGroupMap.advanced = new UIGroup({
      children: advancedProps,
      styles,
      reactObj: this,
    })
  }

  applySettings = (): void => {
    const clone = settings.getAll()
    const emailValues = { ...(clone.email || {}) }
    const editorFont = emailValues.editorFont ?? {}
    this.editorFont = { ...editorFont }

    const localEmail = clone.localSettings?.email ?? {}
    const cloneWithLocal = { ...emailValues, ...localEmail }
    Object.keys(this.uiGroupMap).forEach((key) => {
      this.uiGroupMap[key].setValue(cloneWithLocal, true)
    })

    this.uiGroupMap.compose.setValue(editorFont, true)
    Object.keys(this.uiGroupMap.compose.info).forEach((key) => {
      if ((editorFont as Record<string, unknown>)[key] != null) {
        this.uiGroupMap.compose[key].setValue((editorFont as Record<string, unknown>)[key], true)
      }
    })
  }

  onPropsChange = (key: string, value: any): void => {
    // console.log(' --- onPropsChange : ', key, value)

    // switch (key) {
    //   case 'isUnknownAlwaysShowExternalResources':
    //     break
    //   case 'isKnownAlwaysShowExternalResources':
    //     break
    //   case 'autoAdvanced':
    //   case 'isMarkAsReadWhenOpen':
    //   case 'isMarkAsReadWhenDeleted':
    //   case 'isAutoMarkAsReadWhenReplyingOrForwarding':
    //   default:
    //     notImplemented()
    //     break
    // }

    const { owner } = this.props

    if (owner != null && owner.onChangeValue != null) {
      if (key.startsWith('editorFont')) {
        this.editorFont[key] = value
        owner.onChangeValue('email.editorFont', { ...this.editorFont })
      } else {
        owner.onChangeValue(`email.${key}`, value)
      }
      // localSettings.email에는 변경사항이 없어서 처리하지 않음.
    }
  }

  initAllowedSenders = (): void => {
    dataManager.clearAllowedSenderData()
  }

  getTabsAttrs = (): any => {
    const { owner, isMobile, parentLabel, idx } = this.props
    const { t } = i18n

    if (this.isUICreated === false) {
      this.createUIGroup()
    }

    let defaultActiveKey: string | null = null
    const { selectedTabs } = owner
    if (selectedTabs != null && selectedTabs.length > 1) {
      defaultActiveKey = selectedTabs[1]
    }

    const items = [
      // {
      //   key: 'common',
      //   label: (
      //     <div className={classNames('tabItem', styles.common)}>
      //       <div className={classNames(styles.label)}>{t('settings.emailTabs.common')}</div>
      //     </div>
      //   ),
      //   children: <div className={classNames('panel', styles.common)}>Common</div>,
      // },
      {
        key: 'general',
        label: (
          <div className={classNames('tabItem', 'general', styles.general)}>
            <div className={classNames(styles.label)}>{i18n.t('settings.emailTabs.common')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'general', styles.general)}>
            {this.uiGroupMap.general.getElement()}
          </div>
        ),
      },
      {
        key: 'compose',
        label: (
          <div className={classNames('tabItem', 'compose', styles.compose)}>
            <div className={classNames(styles.label)}>{t('settings.emailTabs.compose')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'compose', styles.compose)}>
            {this.uiGroupMap.compose.getElement()}
          </div>
        ),
      },
      {
        key: 'sendMessage',
        label: (
          <div className={classNames('tabItem', 'sendMessage', styles.sendMessage)}>
            <div className={classNames(styles.label)}>{t('settings.emailTabs.sendMessage')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'sendMessage', styles.sendMessage)}>
            {this.uiGroupMap.sendMessage.getElement()}
          </div>
        ),
      },
      {
        key: 'replyAndForward',
        label: (
          <div className={classNames('tabItem', 'replyAndForward', styles.replyAndForward)}>
            <div className={classNames(styles.label)}>
              {t('settings.emailTabs.replyAndForward')}
            </div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'replyAndForward', styles.replyAndForward)}>
            {this.uiGroupMap.replyAndForward.getElement()}
          </div>
        ),
      },
      {
        key: 'advanced',
        label: (
          <div className={classNames('tabItem', 'advanced', styles.advanced)}>
            <div className={classNames(styles.icon)} />
            <div className={classNames(styles.label)}>{t('settings.emailTabs.advanced')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'advanced', styles.advanced)}>
            {this.uiGroupMap.advanced.getElement()}
          </div>
        ),
      },
    ]

    const tabsAttrs: any = {
      className: classNames('subTabs'),
      items,
      centered: true,
      tabPosition: 'left',
      tabBarExtraContent: isMobile ? { left: parentLabel } : null,
      // onChange: (activeKey) => {
      // },
      onTabClick: (activeKey: string) => {
        const item = items.find((item) => item.key === activeKey)
        if (item != null) {
          const index = parseInt(idx as string, 10)
          owner.mobileViewObj.setKey(1, activeKey, [parentLabel, item.label], index)
        }
      },
    }

    if (defaultActiveKey != null) {
      tabsAttrs.defaultActiveKey = defaultActiveKey
    }

    return tabsAttrs
  }

  render(): React.ReactElement {
    const tabsAttrs = this.getTabsAttrs()

    return (
      <div className={classNames(styles.email)}>
        <OmTabs {...tabsAttrs} />
      </div>
    )
  }
}

export default SettingItem
